import gql from 'graphql-tag';
import { client } from '$lib/utils/shopify/publicStorefrontClient';
import { publish } from '$lib/utils/pubsub';
import { cartUpdate } from '$lib/utils/shopify/cart/events';
import { fragment as cartDataFragment } from '$lib/utils/shopify/fragments/cartFragment';
import InsightWise from '$lib/utils/InsightWise';

// cartUpdate dispatcher
const dipatchChanges = (message) => {
    publish(new cartUpdate(message));
};

function cartInsight(type, { cart, prevCart, change }) {
    const cartInsightItem = InsightWise.createInsightItem.cart(type, { cart, prevCart, change });
    if (cartInsightItem?.type === 'add') InsightWise.add([InsightWise.createInsight.addToCart(cartInsightItem)]);
}

class Cart {
    constructor(cart) {
        this.cartID = cart?.id;
        this.prevCartData = undefined;
        this.setPreviousCart({ cart });
    }

    setPreviousCart(cart) {
        this.prevCartData = JSON.parse(JSON.stringify(cart)); // Hack to block 'reference'
    }

    // add product to cart
    async addToCart(addToCartLines, openDrawer) {
        const addToCartMutation = gql`
            mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
                cartLinesAdd(cartId: $cartId, lines: $lines) {
                    cart {
                        ...cartData
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
            ${cartDataFragment}
        `;
        return new Promise((resolve) => {
            client()
                .mutate({
                    mutation: addToCartMutation,
                    variables: {
                        cartId: this.cartID,
                        lines: addToCartLines
                    }
                })
                .then((response) => {
                    const data = response.data.cartLinesAdd;
                    cartInsight('add', { cart: data, prevCart: this?.prevCartData, change: addToCartLines });
                    this.setPreviousCart(data);
                    const openDrawerState = openDrawer ? openDrawer['openDrawer'] : false;
                    dipatchChanges({ ...data, openDrawerState });
                    resolve(false); // false for cart not adding anymore
                })
                .catch((e) => {
                    console.error(JSON.stringify(e));
                    resolve(false); // false for cart not adding anymore
                });
        });
    }

    // update cart line item (qty & trash)
    async updateCart(id, quantity) {
        const updateCartMutation = gql`
            mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
                cartLinesUpdate(cartId: $cartId, lines: $lines) {
                    cart {
                        ...cartData
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
            ${cartDataFragment}
        `;

        return new Promise((resolve) => {
            client()
                .mutate({
                    mutation: updateCartMutation,
                    variables: {
                        cartId: this.cartID,
                        lines: [
                            {
                                id: id,
                                quantity: quantity
                            }
                        ]
                    }
                })
                .then((response) => {
                    const data = response.data.cartLinesUpdate;
                    cartInsight('update', { cart: data, prevCart: this?.prevCartData, change: { id, quantity } });
                    this.setPreviousCart(data);

                    dipatchChanges(data);
                    resolve(false); // false for cart not updating anymore
                })
                .catch((e) => {
                    console.error(JSON.stringify(e));
                    resolve(false); // false for cart not updating anymore
                });
        });
    }

    // Add attribute to cart
    addCartAttributes(attributesList) {
        const cartAttributesMutation = gql`
            mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
                cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
                    cart {
                        id
                        attributes {
                            key
                            value
                        }
                    }
                    userErrors {
                        field
                        message
                    }
                }
            }
        `;
        return client()
            .mutate({
                mutation: cartAttributesMutation,
                variables: {
                    cartId: this.cartID,
                    attributes: attributesList
                }
            })
            .then((response) => {
                return response.data.cartAttributesUpdate;
            })
            .catch((e) => {
                console.error(JSON.stringify(e));
            });
    }

    // Update Discount in Cart
    async updateCartDiscountCodes(discountCodes) {
        const updateDiscountCodesMutation = gql`
            mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                        ...cartData
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
            ${cartDataFragment}
        `;


        return new Promise((resolve) => {
            client()
                .mutate({
                    mutation: updateDiscountCodesMutation,
                    variables: {
                        cartId: this.cartID,
                        discountCodes,
                    }
                })
                .then((response) => {
                    const data = response.data.cartDiscountCodesUpdate;
                    //cartInsight('update', { cart: data, prevCart: this?.prevCartData, change: { id } });
                    this.setPreviousCart(data);

                    dipatchChanges(data);
                    resolve(false); // false for cart not updating anymore
                })
                .catch((e) => {
                    console.error(JSON.stringify(e));
                    resolve(false); // false for cart not updating anymore
                });
        });
    }
}

export default Cart;
